import { render, staticRenderFns } from "./detailsBrand.vue?vue&type=template&id=a3c406b0&scoped=true&"
import script from "./detailsBrand.vue?vue&type=script&lang=js&"
export * from "./detailsBrand.vue?vue&type=script&lang=js&"
import style0 from "./detailsBrand.vue?vue&type=style&index=0&id=a3c406b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c406b0",
  null
  
)

component.options.__file = "detailsBrand.vue"
export default component.exports